import * as Graph from "../../../GeneratedGraphQL";

import { CustomFonts, defaultBoldFont, defaultRegularFont } from "../theme";

import { css } from "styled-components";

type GetCustomFontsResult = {
  customFontFaces: ReturnType<typeof css>;
  customFonts: CustomFonts;
};

export function getCustomFonts(
  fontConfig?: Graph.Maybe<Graph.Fonts>,
): GetCustomFontsResult {
  const customFontFaces = css`
    ${fontConfig?.bold
      ? css`
          @font-face {
            font-family: "customBold";
            src: url(${fontConfig.bold}) format("woff2");
          }
        `
      : ""}
    ${fontConfig?.regular
      ? css`
          @font-face {
            font-family: "customRegular";
            src: url(${fontConfig.regular}) format("woff2");
          }
        `
      : ""}
  `;
  const customFonts: CustomFonts = {
    bold: fontConfig?.bold ? "customBold" : defaultBoldFont,
    regular: fontConfig?.regular ? "customRegular" : defaultRegularFont,
  };

  return { customFontFaces, customFonts };
}
